import { createFeatureSelector, createSelector } from '@ngrx/store';
import { VaultStoreModule } from './vault-store.module';

export const selectItems = (state: VaultStoreModule) => state;

export const getcurrentVaultUserId = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['userId']) {
        return allItems['Vault']['userId'];
      }
      return null;
    }
  });
export const getcurrentUserFolder = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['folders'] && allItems['Vault']['folders']['userFolder']) {
        return allItems['Vault']['folders']['userFolder'];
      }
      return [];
    }
  });

export const getcurrentForms = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['forms']) {
        return allItems['Vault']['forms'];
      }
      return [];
    }
  });

export const getCurrentFormsById = (id: any) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['forms']) {
        return allItems['Vault']['forms'].find((x) => x.id == id);
      }
      return [];
    }
  });

export const getCategoriesOnType = (categoryType: string) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['categories']) {
        const categories = allItems['Vault']['categories'];
        const categoryList = categories.filter((category) => {
          return category.category_type == categoryType;
        });

        return categoryList;
      }

      return [];
    }
  });

export const getLoader = () =>
  createSelector(selectItems, (allItems) => {
    if (allItems['Vault']['loader']) {
      return true;
    } else {
      return false;
    }
  });

export const getAllPersonalFilesLoader = () =>
  createSelector(selectItems, (allItems) => {
    if (allItems['Vault']['is_personal_files_loading']) {
      return true;
    } else {
      return false;
    }
  });
export const getcurrentUserAdminAccess = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['adminAccess']) {
        return allItems['Vault']['adminAccess'];
      }
      return [];
    }
  });

export const getSharingUserId = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['requestModel']) {
        return allItems['Vault']['requestModel'];
      }
      return [];
    }
  });

export const getVaultItems = (option: string) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['vaults']) {
        return allItems['Vault']['vaults'];
      }
      return [];
    }

    // if (allItems !== null && allItems['Vault']['vaults'] && !allItems['loader']) {
    //   let vaultArr =  allItems['Vault']['vaults'];
    //   if (option == 'Last Updated') {
    //     vaultArr.sort((a, b) => {
    //       if (a.updated_at < b.updated_at) return 1;
    //       if (a.updated_at > b.updated_at) return -1;
    //     });

    //     return vaultArr;
    //   } else if (option == 'A-Z') {
    //     vaultArr.sort((a, b) => {
    //       return a.name.localeCompare(b.name);
    //     });

    //     return vaultArr;
    //   } else if (option == 'Z-A') {
    //     vaultArr.sort((a, b) => {
    //       return b.name.localeCompare(a.name);
    //     });
    //     return vaultArr;
    //   }
    // }
    //  else {
    //   return [];
    // }
  });

export const getSortedVaultItems = (option: string) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['vaults']) {
        const allitems = allItems['Vault']['vaults'];
        return allitems
          .map((element) => ({ ...element, name: element.name ?? element.vault_name, sortOrder: 'asc' }))
          .sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
      }
      return [];
    }
  });

export const getcurrentUserVaultId = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['vaultId']) {
        return allItems['Vault']['vaultId'];
      }
      return [];
    }
  });

export const getDefaultFolders = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['defaultFolders']) {
        return allItems['Vault']['defaultFolders'];
      }
      return [];
    }
  });

export const getTemplateByCategory = (option: string, isAll: boolean) =>
  createSelector(selectItems, (allItems) => {
    {
      let item;
      if (allItems['Vault'] && allItems['Vault']['forms']) {
        const allitems = allItems['Vault'] && allItems['Vault']['forms'];
        if (isAll) {
          item = allitems.filter((it) => it.organization_section == option);
        } else {
          item = allitems.filter((it) => it.organization_group == option);
        }
      }
      return item;
    }
  });

export const getTemplateByCategoryNav = (section: string, folder: string) =>
  createSelector(selectItems, (allItems) => {
    {
      let item;
      if (allItems['Vault'] && allItems['Vault']['forms']) {
        const allitems = allItems['Vault'] && allItems['Vault']['forms'];
        item = allitems.filter((it) => (section ? it.organization_section == section : true) && it.organization_section == folder);
      }
      return item;
    }
  });

export const getTemplateByFolderNav = (section: string) =>
  createSelector(selectItems, (allItems) => {
    {
      let item;
      if (allItems['Vault'] && allItems['Vault']['forms']) {
        const allitems = allItems['Vault'] && allItems['Vault']['forms'];
        item = allitems.filter((it) => it.organization_section == section);
      }
      return item;
    }
  });

export const getTemplateByFolder = (folder: string, isAll: boolean) =>
  createSelector(selectItems, (allItems) => {
    {
      let item;
      if (allItems['Vault'] && allItems['Vault']['forms']) {
        const allitems = allItems['Vault'] && allItems['Vault']['forms'];
        if (isAll) {
          item = allitems.filter((it) => it.organization_section == folder);
        } else {
          item = allitems.filter((it) => it.organization_group == folder);
        }
      }
      return item;
    }
  });

export const getTemplateBySectionNav = (section: string) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['categories']) {
        if (section == 'all_templates') {
          return allItems['Vault']['categories'];
        } else {
          return allItems['Vault']['categories'].filter((it) => it.name == section);
        }
      }
      return [];
    }
  });
export const getTemplateBySectionNavShortcut = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['categories']) {
        return allItems['Vault']['categories'];
      }
      return [];
    }
  });

export const getTemplateBySection = (section: string, isAll: boolean) =>
  createSelector(selectItems, (allItems) => {
    {
      let item;
      if (allItems['Vault'] && allItems['Vault']['forms']) {
        const allitems = allItems['Vault'] && allItems['Vault']['forms'];
        if (isAll) {
          item = allitems;
        } else {
          item = allitems.filter((it) => it.organization_section == section);
        }
      }
      return item;
    }
  });

export const getVaultOnboardItems = (option: string) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['vaults']) {
        return allItems['Vault']['vaults'].filter((vault: any) => vault.type?.toLowerCase() === 'personal' && vault.is_system === true);
      }
      return [];
    }
  });

export const getSharedDataWithMe = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['sharedDataWithMe']) {
        return allItems['Vault']['sharedDataWithMe'];
      }
      return [];
    }
  });

export const getSharedDataByMe = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems['Vault'] && allItems['Vault']['sharedDataByMe']) {
        return allItems['Vault']['sharedDataByMe'];
      }
      return [];
    }
  });
